import { useState, useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import ReviewProjectTemplate from "../../Templates/ReviewProject";
import companyService from "../../../services/Companies/CompanyService";
import useProjectStore from "../../../hooks/useProjectStore";

export default function ReviewProject() {
    const { keycloak, initialized } = useKeycloak();
    const [companies, setCompanies] = useState([]);

    const { project } = useProjectStore();
    
    useEffect(() => {
        loadAllCompanies();
    }, [initialized, keycloak.token])

    const loadAllCompanies = async () => {
        try {
            const allCompanies = await companyService.getAllCompanies(keycloak.token);
            setCompanies(allCompanies);
        } catch (error) {
            console.error("Error to get all companies", error);
        }
    }

    return (
        <ReviewProjectTemplate
            project={project}
            companies={companies}
        />
    )
}